import React, { Fragment } from 'react';
import { round } from 'chameleon-src/utility/utils';
import { TabContent } from 'legacy-packages/ft-cb';

import DonutChart from '../DonutChart/DonutChart';
import BarsContainer from '../Bars/BarsContainer';

import './ChartResults.scss';

const calculatePercentage = (amount, total) => {
  if (!amount || !total) {
    return 0;
  }
  return (100 * amount) / total;
};

export const AVERAGE_POINTS_PIE_LABEL = 'Class Average\nPoints Earned';

/**
 *
 * @param data Charts data
 * @param data.questionsData {array} list of question objects
 * @param data.developingStudentsPercentage {number}
 * @param data.approachingStudentsPercentage {number}
 * @param data.achievingStudentsPercentage {number}
 * @param data.classAverage {number}
 * @param data.pointsAvailable {number}
 * @param amountOfStudents {number}
 * @param children {JSX.Element}
 * @returns {JSX.Element}
 * @constructor
 */
const ChartResults = ({ data, amountOfStudents = 0, children }) => {
  const chartData = [
    {
      color: 'yellow',
      value: data.developingStudentsPercentage,
      title: 'Developing',
    },
    {
      color: 'light-green',
      value: data.approachingStudentsPercentage,
      title: 'Approaching',
    },
    {
      color: 'green',
      value: data.achievingStudentsPercentage,
      title: 'Achieving',
    },
  ];

  const mappedRawData = data.questionsData.map((question) => ({
    ...question,
    questionPercentage: round(
      calculatePercentage(question.correctAnswersGiven, amountOfStudents),
      0,
    ),
    showPopover: false,
  }));

  const content = (
    <Fragment>
      <section>
        <h3>Overall Points</h3>
        <p>Your students&apos; overall score and performance categories</p>
        <div className="donut-chart">
          <DonutChart data={chartData} renderPopover>
            <span data-test-id="pie-chart-scores">
              {data.classAverage}/{data.pointsAvailable}
            </span>
            <p>{AVERAGE_POINTS_PIE_LABEL}</p>
          </DonutChart>
        </div>
      </section>
      <section className="question-level">
        <h3>Question-Level Results</h3>
        <p>The question-by-question performance of your students</p>
        <BarsContainer
          barsData={mappedRawData}
          denominator={amountOfStudents}
          amountOfBars={3}
          hasComparisonPercentages={false}
        />
      </section>
      {children}
    </Fragment>
  );

  return (
    <TabContent>
      <div className="Summary--container">{content}</div>
    </TabContent>
  );
};

export default ChartResults;
